import React from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Row,
  Col,
  Button,
  ButtonGroup,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { useTranslation } from "react-i18next";

const QuickActionsToolbar = ({ range, onRangeChange, onRefresh, loading }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const rangeOptions = [
    { key: "today", label: t("Today") },
    { key: "this_week", label: t("This Week") },
    { key: "this_month", label: t("This Month") },
    { key: "last_month", label: t("Last Month") },
    { key: "this_year", label: t("This Year") }
  ];

  const currentLabel = rangeOptions.find((o) => o.key === range)?.label || t("This Month");

  return (
    <div className="bg-white p-3 rounded shadow-sm border mb-4">
      <Row className="align-items-center g-3">
        {/* Left: Quick Clinical Actions */}
        <Col lg="8" className="d-flex flex-wrap align-items-center gap-2">
          <span className="text-muted fw-semibold font-size-12 me-1 text-uppercase">
            <i className="bx bx-bolt-circle text-warning font-size-16 me-1" />
            {t("Quick Actions")}:
          </span>

          <Button
            color="primary"
            size="sm"
            onClick={() => history.push("/appointment")}
            className="d-inline-flex align-items-center gap-1 shadow-sm font-size-12"
          >
            <i className="bx bx-calendar-plus font-size-14" />
            {t("New Appointment")}
          </Button>

          <Button
            color="info"
            size="sm"
            onClick={() => history.push("/patients")}
            className="d-inline-flex align-items-center gap-1 shadow-sm font-size-12"
          >
            <i className="bx bx-user-plus font-size-14" />
            {t("Register Patient")}
          </Button>

          <Button
            color="success"
            size="sm"
            onClick={() => history.push("/patients")}
            className="d-inline-flex align-items-center gap-1 shadow-sm font-size-12"
          >
            <i className="bx bx-receipt font-size-14" />
            {t("Generate Invoice")}
          </Button>

          <Button
            color="secondary"
            size="sm"
            onClick={() => history.push("/accounts/petty-cash")}
            className="d-inline-flex align-items-center gap-1 shadow-sm font-size-12"
          >
            <i className="bx bx-wallet font-size-14" />
            {t("Record Expense")}
          </Button>

          <Button
            color="warning"
            size="sm"
            onClick={() => history.push("/tasks-notifications")}
            className="d-inline-flex align-items-center gap-1 shadow-sm font-size-12"
          >
            <i className="bx bx-plus-circle font-size-14" />
            {t("Create Task")}
          </Button>
        </Col>

        {/* Right: Date Range Selector & Refresh */}
        <Col lg="4" className="d-flex align-items-center justify-content-lg-end gap-2">
          <UncontrolledDropdown>
            <DropdownToggle
              tag="button"
              className="btn btn-sm btn-light border d-inline-flex align-items-center gap-2 font-size-12 fw-medium"
            >
              <i className="bx bx-calendar text-primary font-size-14" />
              <span>{currentLabel}</span>
              <i className="bx bx-chevron-down ms-1" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end font-size-12 shadow-sm">
              {rangeOptions.map((opt) => (
                <DropdownItem
                  key={opt.key}
                  active={range === opt.key}
                  onClick={() => onRangeChange(opt.key)}
                >
                  {opt.label}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </UncontrolledDropdown>

          <Button
            color="light"
            size="sm"
            onClick={onRefresh}
            disabled={loading}
            title={t("Refresh Analytics")}
            className="border"
          >
            <i className={`bx bx-refresh font-size-15 ${loading ? "bx-spin text-primary" : "text-secondary"}`} />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default QuickActionsToolbar;
